import styled, { keyframes } from "styled-components/macro";

export const PowerOnBox = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0%;
  background: #337fbf;
  border: none;
  text-align: center;
  color: white;
`;

export const PowerOnLogoContainer = styled.div`
  margin-top: 6em;
  margin-bottom: 3rem;
  height: 90px;
  width: auto;
`;
export const PowerOnLogo = styled.img`
  object-fit: contain;
`;

export const PowerOnText = styled.div`
  margin: 0;
`;

export const ProgressBarContainer = styled.div`
  width: 70%;
  height: 10px;
  margin: 0 auto;
  margin-top: 2em;
  background: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;

export const progressAnimation = keyframes`
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
`;

export const ProgressBar = styled.div`
  height: 100%;
  background: #00ff00;
  animation: ${progressAnimation} 4s linear;
  animation-fill-mode: forwards;
  width: ${(props) => (props.progress / 100) * 100}%;
`;

export const Footnote = styled.p`
  position: absolute;
  top: 134%;
  left: 17%;
  margin: 0 auto;
  color: white;
`;
